'use strict';

import documentScroll from './documentScroll';

export default function offset(element)
{
    let box = element.getBoundingClientRect(),
        body = document.body,
        de = document.documentElement,
        clientTop = de && de.clientTop || body.clientTop || 0,
        clientLeft = de && de.clientLeft || body.clientLeft || 0,
        ds = documentScroll(),
        top = box.top + ds.top - clientTop,
        left = box.left + ds.left - clientLeft;
    return { top: top, left: left, width: element.offsetWidth, height: element.offsetHeight };
};
